<template>
  <div id="page-header">

    <!-- DESKTOP -->
    <div class="navbar-desktop">
      <div class="navbar-width justify-content-between align-items-center d-none d-md-flex">
        <router-link class="navbar-btn" to="About">{{ $t('message.headerFooter.aboutUs') }}</router-link>
        <router-link class="navbar-btn" to="Career">{{ $t('message.headerFooter.career') }}</router-link>
        <router-link class="d-none d-md-block navbar-btn" to="/">
          <img src="/static/images/vit-utantext.png" width="28" alt="Precisit">
        </router-link>
        <router-link class="navbar-btn" to="Client">{{ $t('message.headerFooter.client') }}</router-link>
        <router-link class="navbar-btn" to="Contact">{{ $t('message.headerFooter.contact') }}</router-link>

      <div class="lang-menu-desktop justify-content-center align-items-center d-none d-md-flex">
        <button class="language-btn navbar-btn" key="Swedish" @click="changeLocale('se')" v-bind:class="{'chosen-language': chosenLanguage == 'se'}">SE</button>
        <span class="vertical-line"></span>
        <button class="language-btn navbar-btn" key="English" @click="changeLocale('en')" v-bind:class="{'chosen-language': chosenLanguage == 'en'}">EN</button>
      </div>

    </div>
    </div>

  <!-- MOBILE VERSION - HAMBURGER MENU-->
  <div class="pos-f-t fixed-top d-fixed d-md-none">
     <nav class="navbar navbar-dark bg-menu-start" v-bind:class="{'bg-menu-background': menuIsOpened,'bg-menu-scroll': isActive}">
      <div v-on:click="set_bg_menu_background" class="d-flex align-items-center h-100">
      <button class="navbar-toggler navbar-toggler-right collapsed" type="button" data-toggle="collapse"
      data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent"
      aria-expanded="false" aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
      </div>
    </nav>

    <div class="collapse" id="navbarToggleExternalContent">
      <div class="text-center center-right bg-menu-start" v-bind:class="{'bg-menu-background': menuIsOpened, 'bg-menu-scroll': isActive}">

        <div v-on:click="scroll_up">
          <div class="mobile-menu-options" v-on:click="menu_close">
            <router-link class="navbar-btn" data-toggle="collapse" data-target="#navbarToggleExternalContent" to="About">{{ $t('message.headerFooter.aboutUs') }}</router-link>
            <router-link class="navbar-btn" data-toggle="collapse" data-target="#navbarToggleExternalContent" to="Career">{{ $t('message.headerFooter.career') }}</router-link>
            <router-link class="navbar-btn" data-toggle="collapse" data-target="#navbarToggleExternalContent" to="Client">{{ $t('message.headerFooter.client') }}</router-link>
            <router-link class="navbar-btn" data-toggle="collapse" data-target="#navbarToggleExternalContent" to="Contact">{{ $t('message.headerFooter.contact') }}</router-link>
          </div>

          <div class="lang-menu-mobile">
              <button class="language-btn" key="Swedish" @click="changeLocale('se')" v-bind:class="{'chosen-language': chosenLanguage == 'se'}">SE</button>
              <span class="vertical-line"></span>
              <button class="language-btn" key="English" @click="changeLocale('en')" v-bind:class="{'chosen-language': chosenLanguage == 'en'}">EN</button>
          </div>

      </div>
      </div>
    </div>
  </div>

</div>

</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'PageHeader',
  data() {
    return {
      displayScrollUp: 0,
      isActive: false,
      menuIsOpened: false,
      chosenLanguage: i18n.locale,
    };
  },
  methods: {
    changeLocale(locale) {
      i18n.locale = locale;
      this.chosenLanguage = locale;
    },
    // eslint-disable-next-line
    scroll_first_section: function () {
      window.scroll({ top: window.innerHeight, left: 0, behavior: 'smooth' });
    },
    // eslint-disable-next-line
    scroll_listener: function () {
      if (window.pageYOffset >= window.innerHeight) {
        this.displayScrollUp = 1;
        this.isActive = true;
      } else {
        this.displayScrollUp = 0;
        this.isActive = false;
      }
    },
    should_display_scroll_up(disp) {
      return this.displayScrollUp === disp;
    },
    // eslint-disable-next-line
    scroll_up: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    // eslint-disable-next-line
    set_bg_menu_background: function () {
      this.menuIsOpened = !this.menuIsOpened;
    },
    // eslint-disable-next-line
    menu_close: function () {
      this.menuIsOpened = false;
    },
  },
  created() {
    window.addEventListener('scroll', this.scroll_listener);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scroll_listener);
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables.scss';

.navbar-desktop {
  position: absolute;
  top: 1em;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100%;
}

.navbar-width{
  width: 470px;

  @include media-breakpoint-down(md) {
  width: 400px;
  }
}

.vertical-line {
  height: 20px;
  width: 2px;
  background-color: #ffffff;
  border-radius: 99px;
  margin: 0.2rem 0.2rem 0 0.2rem;

  @include media-breakpoint-down(sm) {
  margin: 0.2rem 0.6rem 0 0.6rem;
  }
}

.lang-menu-desktop {
  position: absolute;
  z-index: 1;
  right: 1.5em;
  width: 100px;

  @include media-breakpoint-down(md) {
   right: 0;
  }
}

@mixin nav-btn-style {
  color: $white;
  text-decoration: none;
  font-size: 17px;
  display: block;
}

.navbar-btn {
  @include nav-btn-style;

    @include media-breakpoint-down(sm) {
    padding: 0.4em 0;

    &:first-child {
      padding: 0 0 0.4rem 0;
    }
  }
}

.navbar-btn:hover, .router-link-exact-active {
  transform: scale(1.15);
  text-decoration: none;
}

.language-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;

  @include nav-btn-style;
}

.chosen-language {
  font-weight: bold;
}

.language-line {
  color: $white;
  font-size: 1em;
}

//MOBILE

.lang-menu-mobile {
  padding: 1.5rem 0 3rem 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 1;
}


.navbar-toggler span {
   display: block;
   background-color: $white;
   height: 2px;
   width: 25px;
   margin-top: 4px;
   margin-bottom: 4px;
   z-index: 40;
   -webkit-transform: rotate(0deg);
   -moz-transform: rotate(0deg);
   -o-transform: rotate(0deg);
   transform: rotate(0deg);
}

.navbar {
  height: 50px;
  padding: 0;
}

.bg-menu-start {
transition: background-color 0.4s linear;
 background-color:rgba(0, 0, 0, 0.25);
}

.bg-menu-scroll {
 transition: background-color 0.4s linear;
 background-color:rgba(30, 64, 81, 0.9);
}

.bg-menu-background {
  transition: background-color 0.4s linear;
  background-color:rgba(30, 64, 81, 0.9);
}

.navbar-toggler{
  position:absolute;
  right:10px;
  border: 0;
}

button:focus {
  outline: 0;
  border: none;
}

.navbar-toggler span:nth-child(1),
.navbar-toggler span:nth-child(3) {
   -webkit-transition: transform .35s ease-in-out;
   -moz-transition: transform .35s ease-in-out;
   -o-transition: transform .35s ease-in-out;
   transition: transform .35s ease-in-out;
}

.navbar-toggler:not(.collapsed) span:nth-child(1) {
    position: absolute;
    left: 12px;
    top: 10px;
    -webkit-transform: rotate(135deg);
    -moz-transform: rotate(135deg);
    -o-transform: rotate(135deg);
    transform: rotate(135deg);
}

.navbar-toggler:not(.collapsed) span:nth-child(2) {
    height: 12px;
    visibility: hidden;
    background-color: transparent;
}

.navbar-toggler:not(.collapsed) span:nth-child(3) {
    position: absolute;
    left: 12px;
    top: 10px;
    -webkit-transform: rotate(-135deg);
    -moz-transform: rotate(-135deg);
    -o-transform: rotate(-135deg);
    transform: rotate(-135deg);
}

</style>
